import React, { Fragment, useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { map } from "ramda";

import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import Typography from "@material-ui/core/Typography";

import MediaDialog from "../common/MediaDialog";
import { isBlank, notBlank } from "../../util/ext";
import PanelLoadingIndicator from "../../components/PanelLoadingIndicator";
import LuxonUtils from "@date-io/luxon";
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import { getSubmissionReportUrl } from "../cspServices";

const useStyles = makeStyles(theme => ({
  actions: {
    padding: theme.spacing(5),
  },

  badge: {
    background: "rgba(125, 218, 252, 0.5)",
    borderRadius: 4,
    padding: "8px 12px",
    gap: 10,
    width: "auto",
    height: 32,
  },

  button: {
    width: "auto",
    textTransform: "capitalize",
  },

  mediaType: {
    fontWeight: 700,
    fontSize: 14,
    lineHeight: "16px",
    color: theme.palette.primary.main,
  },

  otherReason: {
    lineHeight: "2.5rem",
    maxHeight: 150,
    overflowY: "auto !important",
  },

  rejected: {
    backgroundColor: theme.palette.rejected,
    "&:hover": {
      backgroundColor: "rgba(176, 34, 12, 0.7)",
    },
  },

  title: {
    color: theme.palette.primary.darker,
    fontSize: "2.4rem",
    lineHeight: "3.2rem",
  },
}));

const CspSubmissionReportDialog = props => {
  const { open, handleClose, projects } = props;
  const classes = useStyles();

  const [project, setProject] = useState({});
  useEffect(() => {
    if (notBlank(projects)) {
      setProject(projects[0].projectId);
    }
  }, [projects, setProject]);

  const handleChange = event => {
    const project = event.target.value;
    setProject(project);
  };

  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());

  const handleCloseClick = () => {
    handleClose();
  };

  return (
    <Fragment>
      <MediaDialog
        open={open}
        titleClassName={classes.title}
        title="CSP Submission Report"
        handleClose={handleCloseClick}
        content={
          isBlank(projects) ? (
            <PanelLoadingIndicator />
          ) : (
            <Grid container spacing={4}>
              <MuiPickersUtilsProvider utils={LuxonUtils}>
                <Grid item xs={12}>
                  <Typography>
                    Select a Project and date range for the CSP Submission
                    Report
                  </Typography>
                </Grid>

                <Grid item xs={12}>
                  <FormControl fullWidth>
                    <InputLabel>Select a project</InputLabel>
                    <Select
                      labelId="rejection-reason-label"
                      id="rejection-reason"
                      value={project}
                      onChange={handleChange}
                      MenuProps={{
                        anchorOrigin: {
                          vertical: "bottom",
                          horizontal: "left",
                        },
                        transformOrigin: {
                          vertical: "top",
                          horizontal: "left",
                        },
                        getContentAnchorEl: null,
                      }}
                    >
                      {map(
                        project => (
                          <MenuItem
                            key={`project-${project.projectId}`}
                            value={project.projectId}
                          >
                            {project.projectName}
                          </MenuItem>
                        ),
                        projects,
                      )}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={6}>
                  <KeyboardDatePicker
                    required={true}
                    disableToolbar
                    fullWidth
                    autoOk
                    id="startDate"
                    format="MM/dd/yyyy"
                    label="Start Date"
                    variant="inline"
                    value={startDate}
                    onChange={value => setStartDate(value)}
                    KeyboardButtonProps={{
                      "aria-label": "change start date",
                    }}
                  />
                </Grid>

                <Grid item xs={6}>
                  <KeyboardDatePicker
                    required={true}
                    disableToolbar
                    fullWidth
                    autoOk
                    id="endDate"
                    format="MM/dd/yyyy"
                    label="End Date"
                    variant="inline"
                    value={endDate}
                    onChange={value => setEndDate(value)}
                    KeyboardButtonProps={{
                      "aria-label": "change start date",
                    }}
                  />
                </Grid>
              </MuiPickersUtilsProvider>
            </Grid>
          )
        }
        actionsClassName={classes.actions}
        actions={
          <Grid container alignItems="center">
            <Button
              variant="contained"
              href={getSubmissionReportUrl(project, startDate, endDate)}
              component="a"
              target="_blank"
              classes={{
                root: classes.button,
              }}
            >
              Submit
            </Button>
            <Button onClick={handleCloseClick}>Cancel</Button>
          </Grid>
        }
      />
    </Fragment>
  );
};

export default CspSubmissionReportDialog;
